/**
 * After a deploy, a tab opened on the previous version asks for chunks that no longer exist
 * (their hashed names changed). A single reload fetches the new index.html and fixes it. The
 * guard stops a reload loop when the failure has another cause (offline, broken deploy).
 */
const KEY = 'syncra.chunkReloadAt';
const WINDOW_MS = 30_000;

const CHUNK_ERROR = /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS/i;

export function isChunkLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : typeof error === 'string' ? error : '';
  return CHUNK_ERROR.test(message);
}

/** Reloads the page unless it already did so in the last 30 s. Returns whether it reloaded. */
export function reloadOnceForNewVersion(reload: () => void = () => window.location.reload()): boolean {
  let last = 0;
  try {
    last = Number(sessionStorage.getItem(KEY) ?? 0);
  } catch {
    /* storage unavailable: still try once */
  }
  if (Date.now() - last < WINDOW_MS) return false;
  try {
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    /* ignore */
  }
  reload();
  return true;
}

/** Vite fires `vite:preloadError` when a dynamic import fails; recover by loading the new version. */
export function installChunkRecovery(): void {
  window.addEventListener('vite:preloadError', (event) => {
    if (reloadOnceForNewVersion()) event.preventDefault();
  });
}
